<template>
   <div class="popup panel-left-dateTime panel-left-comm popup-dateTime cruise_search cruise-search-popup" 
   :class="{in: isShow}"
   id="panel-left-dateTime" data-type="row">
        <div class="popup-head">
            <a @click="goBack()" class="js-returnDetailBtn">
                <img src="https://resource.rcclchina.com.cn/homePage/mobile/leftalllow.png" alt="">
            </a>
            选择出发时间
        </div>
        <!--日历-->
        <div class="date-wrapper search-form-container" data-key="SailDate">

            <div class="date-content">
                <div class="year">
                    {{getCalendarYear(0)}}年
                </div>
                <div class="date-table">
                    <div v-for="i in 3" :key="i" class="table-row">
                        <div v-for="line in 4" :key="line" 
                        class="sailDate-search-form-month search-form-list-item table-cell"
                        @click="onSailDateClick(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true))" 
                        :class="{ 
                            active: isSelected(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true)),
                            disable: isDisable(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true))
                        }">{{getCalendarMonth(i, line, false)}}月</div>
                    </div>

                </div>
            </div>

            <div class="date-content">
                <div class="year">
                    {{getCalendarYear(1)}}年
                </div>
                <div class="date-table">
                    <div v-for="i in 3" :key="i" class="table-row">
                        <div v-for="line in 4" :key="line" 
                        class="sailDate-search-form-month search-form-list-item table-cell"
                        @click="onSailDateClick(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true))" 
                        :class="{ 
                            active: isSelected(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true)),
                            disable: isDisable(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true))
                        }">{{getCalendarMonth(i, line, false)}}月</div>
                    </div>

                </div>
            </div>

             <div v-if="shouldShowPageTwo" class="date-content">
                <div class="year">
                    {{getCalendarYear(2)}}年
                </div>
                <div class="date-table">
                    <div v-for="i in 3" :key="i" class="table-row">
                        <div v-for="line in 4" :key="line" 
                        class="sailDate-search-form-month search-form-list-item table-cell"
                        @click="onSailDateClick(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true))" 
                        :class="{ 
                            active: isSelected(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true)),
                            disable: isDisable(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true))
                        }">{{getCalendarMonth(i, line, false)}}月</div>
                    </div>

                </div>
            </div>

            

        </div>

        <div class="click-btn">
            <a class="reset-btn" @click="onClearClick()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-reset.png" /> 重置</a>
            <a class="define-btn" @click="goBack()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-define.png"  /> 确定</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SailDateForm',
    components: {
        
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        },
        closeForm: {
            type: Function
        }
    },
    data () {
        return {
            today: new Date(),
            currentIndex: 0,
            selectedSailDates: []
        }
    },
    methods: {
        goBack() {
            this.closeForm()
        },
        getCalendarYear (addYear) {
            return this.today.getFullYear() + addYear
        },
        getCalendarMonth (i, lineIndex, needPrefix) {
            let monthStr = ""
            let month = 4 * (i - 1) + lineIndex
            if (month > 12) {
                return monthStr
            }
            if (!needPrefix) {
                return month + ""
            }
            monthStr = month + ""
            if (month < 10) {
                monthStr = "0" + month
            }
            return monthStr
        },
        changeIndex(direction) {
            if (direction == 'left' && this.currentIndex > 0) {
                this.currentIndex--
            } else if (direction == 'right' && this.currentIndex < 1) {
                this.currentIndex++
            }
        },
        onSailDateClick (sailDate) {
            if (this.isDisable(sailDate)) {
                return
            }
            const cruiseType = this.cruiseType
            const data = {
                cruiseType,
                key: 'sailDates',
                values: [{
                    code: sailDate,
                    name: sailDate
                }]
            }
            if (!this.selectedSailDates.includes(sailDate)) {
                this.selectedSailDates.push(sailDate)
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            } else {
                this.selectedSailDates = this.selectedSailDates.filter(item=>!(item == sailDate))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            }
        },
        isSelected (sailDate) {
            return this.selectedSailDates.includes(sailDate)
        },
        onClearClick () {
            const data = {
                cruiseType: this.cruiseType,
                key: 'sailDates',
                values: this.selectedSailDates
            }
            this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            this.selectedSailDates = []
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].sailDates
            return !availableItems.includes(code)
        }
    },
    computed: {
        shouldShowPageTwo () {
            return true
        }
    }
}
</script>
